/* eslint-disable consistent-return */
import React, { useEffect, useState } from 'react';
// import CardConsultancyLegal from 'components/atoms/card_consultancy_legal';
import { useDispatch, useSelector } from 'react-redux';
import { createDica, getPosts } from 'store/modules/consultancy_legal_store/actions';
import { ApplicationState } from 'store';
import { ConsultancyLegalState } from 'store/modules/consultancy_legal_store/types';
// import Loader from 'components/atoms/loader';
import { Container } from './styles';

const ConsultancyLegalList = () => {
  const dispatch = useDispatch();
  const [query, setQuery] = useState<string>('');
  const [showSuccessAlert, setShowSuccessAlert] = useState<boolean>(false);
  const [showErrorAlert, setShowErrorAlert] = useState<boolean>(false);

  const { request } = useSelector<ApplicationState, ConsultancyLegalState>(
    (state) => state.session.dica_legal,
  );

  const handleClick = async () => {
    (async () => {
      dispatch(createDica(query));
    })();
  };

  useEffect(() => {
    dispatch(getPosts());
    document.title = 'Consultoria em licitações - ConLicitação';
  }, [dispatch]);

  useEffect(() => {
    setQuery('');
    if (request?.create?.loaded) {
      setShowSuccessAlert(true);
      const timer = setTimeout(() => setShowSuccessAlert(false), 2000);
      return () => clearTimeout(timer);
    }
    if (request?.create?.error) {
      setShowErrorAlert(true);
      const timer = setTimeout(() => setShowErrorAlert(false), 2000);
      return () => clearTimeout(timer);
    }
  }, [request?.create?.loaded, request?.create?.error]);

  return (
    <Container>
      <div className="container">
        <div className="row">
          <div className="col-md-12 mb-3">
            <h3>Consultoria em licitações</h3>
            <p>Está com dúvidas juridicas? Envie para o nosso time.</p>
            {showErrorAlert && (
              <div className="alert alert-danger text-center" role="alert">
                Erro ao enviar dúvida, por favor tente mais tarde!
              </div>
            )}
            {showSuccessAlert && (
              <div className="alert alert-success text-center" role="alert">
                Dúvida enviada com sucesso!
              </div>
            )}
            <div className="form-group">
              <textarea
                className="form-control"
                id="duvida"
                name="duvida"
                placeholder="Digite a sua dúvida "
                rows={5}
                value={query}
                onChange={(event) => setQuery(event.target.value)}
              />
            </div>
            <button
              type="button"
              className="btn btn-primary"
              onClick={handleClick}
              disabled={query === '' || request?.create?.loading}
            >
              Enviar dúvida
            </button>
            {/* <h3 className="mt-5">Dicas legais</h3>
            <p>Preparamos diversos conteúdos com base em dúvidas de outros usuários. </p>
            <div className="row">
              <div className="col-md-12">
                {request?.get_posts?.loading ? (
                  <Loader />
                ) : (
                  <div className="card-columns">
                    {dica_legal?.dica_legal?.map((dica) => (
                      <CardConsultancyLegal
                        key={dica?.id}
                        title={dica?.title?.rendered}
                        description={dica?.excerpt?.rendered}
                        post_id={dica?.id}
                      />
                    ))}
                  </div>
                )}
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </Container>
  );
};

export default ConsultancyLegalList;
